module.exports = __webpack_public_path__ + "img/left.3ab3e2d8.png";